import React from 'react'
import Cards from './Cards'

export default function Layout() {
  return (
    <div >
        <Cards />
    </div>
  )
}
